import React from 'react';
import { ArcherContainer, ArcherElement } from 'react-archer';
import SpeakIt from './CompAISpeakIt'; // Assuming SpeakIt is in the same directory

export default function CompAIStoryBoardLeadership({ researchDeepData }) {
    if (!researchDeepData || !researchDeepData.storyTitle) {
        return null; // Or some loading/error state
    }

    return (
        <div className="ml-5 animate__animated animate__fadeIn">
            {/* Path Forward Section */}
            {researchDeepData.pathForward && (
                <ArcherContainer strokeColor="rgba(74, 222, 128, 0.6)" strokeWidth={2}>
                    <div className="mb-8 flex flex-col md:flex-row gap-0">
                        {/* Left column - Summary */}
                        <div className="w-7/12 pr-7">
                            <h3 className="text-4xl text-zinc-50 mb-4 sp-big-heading">Leadership Story</h3>
                            <h3 className="text-2xl text-zinc-50 mb-3">{researchDeepData.storyTitle}</h3>
                            <p className="text-zinc-200 text-base leading-8">{researchDeepData.introduction}</p>

                            <div className="gap-y-4 -mx-4">
                                <ArcherElement
                                    id="vision-summary"
                                    relations={[{
                                        targetId: 'vision-box',
                                        targetAnchor: 'left',
                                        sourceAnchor: 'right',
                                        startMarker: false,
                                        endMarker: false,
                                        style: {
                                            strokeColor: '#46608B', strokeWidth: 2, strokeDasharray: '2,5', markerEnd: 'none',
                                            markerStart: 'none'
                                        }
                                    }]}
                                >
                                    <p className="text-zinc-100 my-4 text-base leading-8 border-sky-400/50 bg-black/20 rounded-l-lg border-r-2 p-4">{researchDeepData.vision.summary}</p>
                                </ArcherElement>

                                <ArcherElement
                                    id="challenges-summary"
                                    relations={[{
                                        targetId: 'challenges-box',
                                        targetAnchor: 'left',
                                        sourceAnchor: 'right',
                                        startMarker: false,
                                        endMarker: false,
                                        style: {
                                            strokeColor: '#f8717180', strokeWidth: 2, strokeDasharray: '2,5', markerEnd: 'none',
                                            markerStart: 'none'
                                        }
                                    }]}
                                >
                                    <p className="text-zinc-100 my-4 text-base leading-8 border-red-400/50 bg-black/20 rounded-l-lg border-r-2 p-4">{researchDeepData.challenges.summary}</p>
                                </ArcherElement>

                                <ArcherElement
                                    id="path-forward-summary"
                                    relations={[{
                                        targetId: 'path-forward-box',
                                        targetAnchor: 'left',
                                        sourceAnchor: 'right',
                                        endShape: 'circle',
                                        startMarker: false,
                                        endMarker: false,
                                        style: {
                                            strokeColor: '#437660', strokeWidth: 2, strokeDasharray: '2,5', markerEnd: 'none',
                                            markerStart: 'none'
                                        }
                                    }]}
                                >
                                    <p className="text-zinc-100 my-4 text-base leading-8 border-green-400/50 bg-black/20 rounded-l-lg border-r-2 p-4">{researchDeepData.pathForward.summary}</p>
                                </ArcherElement>

                                <p className="text-zinc-200 my-4 leading-8 text-base p-4 rounded-lg ">{researchDeepData.conclusion}</p>
                            </div>
                        </div>

                        {/* Right column - Heading, image and bullets */}
                        <div className="w-5/12">
                            <div className="pl-14 pt-6 mb-8 animate__animated animate__fadeIn">
                                <div className="mx-8">
                                    <SpeakIt textToSpeak={researchDeepData.introduction + researchDeepData.vision.summary + researchDeepData.challenges.summary + researchDeepData.pathForward.summary + researchDeepData.conclusion}
                                        title={researchDeepData.storyTitle}
                                    />
                                </div>

                                <ArcherElement id="vision-box">
                                    <div className="bg-sky-900/10 rounded-lg p-6 mb-8 mx-8 animate__animated animate__fadeIn">
                                        <div className="flex items-center gap-4 mb-4">
                                            <div className="rounded w-12 h-12 flex items-center justify-center bg-sky-900/30">
                                                <img src="/util/app/b3-admin-north-star.svg" className="h-8 w-8" alt="Vision" />
                                            </div>
                                            <h4 className="text-xl font-medium text-sky-300">Vision</h4>
                                        </div>
                                        <div>
                                            <ul className="space-y-2 mt-3">
                                                {researchDeepData.vision.keyGoals.map((goal, i) => (
                                                    <li key={i} className="text-zinc-200 flex items-start gap-4">
                                                        <span className="text-sxky-400">{goal}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </ArcherElement>
                                <ArcherElement id="challenges-box">
                                    <div className="bg-red-900/10 rounded-lg p-6 mb-8 mx-8 animate__animated animate__fadeIn">
                                        <div className="flex items-center gap-4 mb-4">
                                            <div className="rounded w-12 h-12 flex items-center justify-center bg-red-900/25">
                                                <img src="/util/app/b3-admin-challenges-b.svg" className="h-8 w-8" alt="Challenges" />
                                            </div>
                                            <h4 className="text-xl font-medium text-red-300">Challenges</h4>
                                        </div>
                                        <div>
                                            <ul className="space-y-2 mt-3">
                                                {researchDeepData.challenges.keyChallenges.map((challenge, i) => (
                                                    <li key={i} className="text-zinc-200 flex items-start gap-2">
                                                        <span className="text-rexd-300">{challenge}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </ArcherElement>
                                <ArcherElement id="path-forward-box">
                                    <div className="bg-green-900/10 rounded-lg p-6 mb-8 mx-8 animate__animated animate__fadeIn">
                                        <div className="flex items-center gap-4 mb-4">
                                            <div className="rounded w-12 h-12 flex items-center justify-center bg-green-900/30">
                                                <img src="/util/app/b3-admin-path-2.svg" className="h-8 w-8" alt="Path Forward" />
                                            </div>
                                            <h4 className="text-xl font-medium text-green-300">Path Forward</h4>
                                        </div>
                                        <div>
                                            <ul className="space-y-2 mt-3">
                                                {researchDeepData.pathForward.strategies.map((strategy, i) => (
                                                    <li key={i} className="text-zinc-200 flex items-start gap-2">
                                                        <span className="text-grexen-300">{strategy}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </ArcherElement>
                            </div>
                        </div>
                    </div>
                </ArcherContainer>
            )}
        </div>
    );
} 